import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { JaneDoePostCardStackBackgroundViewModel } from './jane-doe-post-card-stack-background-view-model';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-jane-doe-post-card-stack-background',
  templateUrl: './jane-doe-post-card-stack-background.component.html',
  styleUrls: ['./jane-doe-post-card-stack-background.component.scss'],
  providers: [JaneDoePostCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class JaneDoePostCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: JaneDoePostCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
